module.exports = __webpack_public_path__ + "static/mccalla-coaching-header-background-f835c200157f1c90618e8b0b635282aa.webp";